import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Grid, Popup, Button, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

const {deleteInternalUserByGroup, deleteExternalUserByGroup} = Actions;

const DeleteIcon = ({group, username, email, dataType}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleDeleteClick = () => {
    if (dataType === 'internal') {
      dispatch(deleteInternalUserByGroup(group, username));
    } else {
      dispatch(deleteExternalUserByGroup(group, email));
    }

    handleClose();
  };

  return (
    <Popup
      wide
      inverted
      on='click'
      position='top center'
      open={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      trigger={<Icon name='delete' color='red' size='big' />}
    >
      <Grid>
        <Grid.Row>
          <Grid.Column textAlign='center'>
            <div>{`¿Desea eliminar ${username}?`}</div>
            <Button secondary size='mini' onClick={handleClose}>
              CANCELAR
            </Button>
            <Button primary size='mini' onClick={handleDeleteClick}>
              ELIMINAR
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Popup>
  );
};

export default DeleteIcon;
